import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
function pad(n: number): string {
  return n.toString().padStart(2, '0');
}
export function UrgencyBar() {
  const [secondsLeft, setSecondsLeft] = useState<number>(59 * 60 + 59);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSecondsLeft(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  return <div className="sticky top-0 z-50 w-full bg-alert text-white" data-id="element-105" data-mp="2p5lgcv74600j">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-1 px-4 py-2.5 text-center sm:flex-row sm:justify-center sm:gap-3" data-id="element-106" data-mp="2p63oap3522oa">
        <p className="flex items-center gap-2 text-[13px] font-semibold leading-snug sm:text-sm" data-id="element-107" data-mp="2f7eap8i9z4du">
          <ZapIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-108" data-mp="2b5sx1kxx2m2l" />
          <span data-id="element-109" data-mp="2b6m0od1kwvgi">
            OFERTA RELÁMPAGO: el método completo por solo{' '}
            <span className="font-extrabold" data-id="element-110" data-mp="1rvpz1i2is8nf">$6.39</span>. Subirá a $27 al
            finalizar el contador:
          </span>
        </p>
        <span className="rounded-md bg-white/15 px-2.5 py-1 font-mono text-sm font-bold tabular-nums tracking-widest" role="timer" aria-live="off" data-id="element-111" data-mp="1wpu3nuobc4lc">
          {pad(hours)}:{pad(minutes)}:{pad(seconds)}
        </span>
      </div>
    </div>;
}